import { merchantIdentifier } from 'constants/';

const existsApplePayJsApi = async () => {
  return new Promise((resolve, reject) => {
    try {
      const enabled = ApplePaySession?.canMakePayments();

      resolve(enabled);
    } catch (err) {
      reject(new Error(JSON.stringify(err)));
    }
  });
};

const isApplePayJsAvailable = async () => {
  await existsApplePayJsApi();

  return ApplePaySession?.canMakePaymentsWithActiveCard(merchantIdentifier ?? '');
};

export { isApplePayJsAvailable };
